import React, { useEffect, useState } from "react";
import RecentList from "./lists/RecentList";
import RecentBack from "./back/RecentBack";



function Nouveautes() {
    return (
        <section className="section_l">
            <div className="container_news">
                <h3 className="categorie">Nouveautés</h3>
                <div className="back">
                    <RecentBack />
                </div>
                <RecentList />
            </div>
        </section>

    )
}

export default Nouveautes;